import React from "react";

const DetailsIcon = ({ fill = "#344054", width = "20px", height = "20px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 17.5V15.8333C13.3333 14.2617 13.3333 13.4767 12.8449 12.9883C12.3566 12.5 11.5716 12.5 9.99992 12.5H9.16659C7.59492 12.5 6.80992 12.5 6.32159 12.9883C5.83325 13.4767 5.83325 14.2617 5.83325 15.8333V17.5"
        stroke={fill}
        stroke-width="2"
      />
      <path
        d="M5.83325 6.66666H9.99992"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M2.5 7.5C2.5 5.14333 2.5 3.96417 3.2325 3.2325C3.96417 2.5 5.14333 2.5 7.5 2.5H13.4767C13.8167 2.5 13.9875 2.5 14.14 2.56333C14.2925 2.62667 14.4142 2.74667 14.655 2.98833L17.0117 5.345C17.2533 5.58667 17.3733 5.70667 17.4367 5.86C17.5 6.0125 17.5 6.18333 17.5 6.52333V12.5C17.5 14.8567 17.5 16.0358 16.7675 16.7675C16.0358 17.5 14.8567 17.5 12.5 17.5H7.5C5.14333 17.5 3.96417 17.5 3.2325 16.7675C2.5 16.0358 2.5 14.8567 2.5 12.5V7.5Z"
        stroke={fill}
        stroke-width="2"
      />
    </svg>
  );
};

export default DetailsIcon;
